/* =============================================================================
   sticky-atc.js — D5 移动端 sticky 加购条（custom element <sticky-atc>）
   机制复用：点击 = 触发主商品表单 requestSubmit()，AJAX 加购/购物车反馈
   全部由 Dawn 的 product-form.js 处理（本组件不碰任何购物车逻辑）。
   - 显隐：IntersectionObserver 观察主表单——表单滚出视口上方后出现
   - 价格同步：监听区段内变体 change，镜像 price 区块文本
   - 可售同步：镜像主按钮 disabled 状态（缺货置灰）
   无 JS：整个 sticky 条不渲染（no-js-hidden）
============================================================================= */
class StickyAtc extends HTMLElement {
  connectedCallback() {
    this.formId = this.dataset.formId;
    this.form = this.formId ? document.getElementById(this.formId) : null;
    if (!this.form) return;

    this.button = this.querySelector('[data-sticky-add]');
    this.priceEl = this.querySelector('[data-sticky-price]');
    this.section = this.closest('.shopify-section') || document;

    // 表单滚出视口（上方）→ 显示 sticky
    this._onIntersect = (entries) => {
      const entry = entries[0];
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.classList.toggle('is-visible', scrolledPast);
    };
    this.observer = new IntersectionObserver(this._onIntersect, { rootMargin: '0px', threshold: 0 });
    this.observer.observe(this.form);

    // 点击 → 复用主表单提交（Dawn product-form.js 接管 AJAX）
    this._onClick = () => {
      if (typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit();
      } else {
        this.form.submit();
      }
    };
    this.button.addEventListener('click', this._onClick);

    // 变体变化 → 同步价格与可售状态（change 从 variant-selects/数量器冒泡上来）
    this._onVariantChange = () => this.syncFromMain();
    this.section.addEventListener('change', this._onVariantChange);
    this.syncFromMain();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.button) this.button.removeEventListener('click', this._onClick);
    if (this.section) this.section.removeEventListener('change', this._onVariantChange);
  }

  syncFromMain() {
    // 价格：镜像 price 区块（Dawn 变体切换后就地更新该区块）
    const priceSource = document.getElementById(`price-${this.dataset.sectionId}`) || null;
    if (this.priceEl && priceSource) {
      const priceText = priceSource.querySelector('.price__container, .price')?.textContent;
      if (priceText) this.priceEl.textContent = priceText.replace(/\s+/g, ' ').trim();
    }
    // 可售：镜像主表单提交按钮的 disabled
    const mainSubmit = this.form.querySelector('[type="submit"][name="add"]');
    if (mainSubmit && this.button) {
      this.button.disabled = mainSubmit.disabled;
      this.button.classList.toggle('loading', mainSubmit.classList.contains('loading'));
    }
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyAtc);
}
